import { render, staticRenderFns } from "./BrushOption.vue?vue&type=template&id=18883a52&scoped=true"
import script from "./BrushOption.vue?vue&type=script&lang=js"
export * from "./BrushOption.vue?vue&type=script&lang=js"
import style0 from "./BrushOption.vue?vue&type=style&index=0&id=18883a52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18883a52",
  null
  
)

export default component.exports